var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signing_password_show",
    transform: "translate(-1066 -516)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 24,
    height: 24,
    transform: "translate(1066 516)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "view_1_",
    "data-name": "view (1)",
    transform: "translate(1067.499 429.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M10.5,105.441c-3.931,0-7.694-2.892-10.178-5.894a1.406,1.406,0,0,1,0-1.791A21.042,21.042,0,0,1,4,94.273c4.4-3.205,8.58-3.212,12.992,0a21.445,21.445,0,0,1,3.682,3.484,1.406,1.406,0,0,1,0,1.791C18.195,102.549,14.432,105.441,10.5,105.441Zm0-12.285c-4.354,0-8.129,4.152-9.182,5.425a.112.112,0,0,0,0,.142c1.053,1.273,4.828,5.425,9.182,5.425s8.129-4.152,9.182-5.425a.113.113,0,0,0,0-.142c-1.053-1.273-4.828-5.425-9.182-5.425Z",
    transform: "translate(0 0)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M152.435,156.742a4.485,4.485,0,1,1,4.613-4.483A4.554,4.554,0,0,1,152.435,156.742Zm0-7.685a3.2,3.2,0,1,0,3.295,3.2A3.253,3.253,0,0,0,152.435,149.057Z",
    transform: "translate(-141.934 -53.607)",
    fill: "#bdbdbd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOutlined);
export default __webpack_public_path__ + "static/media/eye_outlined.c7997bcc.svg";
export { ForwardRef as ReactComponent };